(function () {
  'use strict';

  const STORAGE_KEY = 'boxi_quote_bridge_boxes';

  const NativeRequest = window.Request;
  const NativeFetch = window.fetch.bind(window);

  /*
   * ============================================================
   * 1. BOXI-ZUSAMMENSETZUNG ABFANGEN
   * ============================================================
   *
   * Wir lesen den ursprünglichen /cart/add.js Request von Boxi.
   * Der echte Shopify-Warenkorb wird dabei NICHT verändert.
   */

  if (
    NativeRequest &&
    !window.__boxiQuoteBridgeRequestInstalled
  ) {
    window.__boxiQuoteBridgeRequestInstalled = true;

    window.Request = class extends NativeRequest {
      constructor(input, init) {
        super(input, init);

        try {
          const url =
            typeof input === 'string'
              ? input
              : input && input.url
                ? input.url
                : '';

          if (!url.includes('/cart/add.js')) {
            return;
          }

          if (
            !init ||
            typeof init.body !== 'string'
          ) {
            return;
          }

          const payload = JSON.parse(init.body);

          if (
            !payload ||
            !Array.isArray(payload.items)
          ) {
            return;
          }

          const boxItems =
            payload.items.filter(function (item) {
              return (
                item &&
                item.properties &&
                item.properties._boxi_box_id
              );
            });

          if (!boxItems.length) {
            return;
          }

          let saved = {};

          try {
            saved =
              JSON.parse(
                localStorage.getItem(STORAGE_KEY)
              ) || {};
          } catch (e) {
            saved = {};
          }

          boxItems.forEach(function (item) {
            const p = item.properties || {};

            const boxId = String(
              p._boxi_box_id || ''
            );

            if (!boxId) {
              return;
            }

            if (!saved[boxId]) {
              saved[boxId] = {
                box_id: boxId,
                builder_id:
                  p._boxi_builder_id || '',
                parent_id:
                  String(
                    p._boxi_parent_id || ''
                  ),
                box_name:
                  p.Box || '',
                items: []
              };
            }

            saved[boxId].items.push({
              variant_id: String(item.id),
              quantity: Number(
                p._boxi_quantity ||
                item.quantity ||
                1
              )
            });
          });

          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(saved)
          );

          console.log(
            '[Boxi Quote Bridge] Box captured:',
            saved
          );

        } catch (error) {
          console.warn(
            '[Boxi Quote Bridge] Capture failed:',
            error
          );
        }
      }
    };
  }


  /*
   * ============================================================
   * 2. PRODUKTNAMEN DIREKT AUS SHOPIFY HOLEN
   * ============================================================
   */

  async function getVariantName(variantId) {
    try {
      const response =
        await NativeFetch(
          '/variants/' +
            encodeURIComponent(variantId) +
            '.js',
          {
            headers: {
              Accept: 'application/json'
            },
            credentials: 'same-origin'
          }
        );

      if (!response.ok) {
        return 'Artikel ' + variantId;
      }

      const variant =
        await response.json();

      return (
        variant.product_title ||
        variant.name ||
        variant.title ||
        'Artikel ' + variantId
      );

    } catch (error) {
      return 'Artikel ' + variantId;
    }
  }


  async function buildReadableContents(box) {
    const parts = [];

    for (const item of box.items || []) {
      const name =
        await getVariantName(
          item.variant_id
        );

      parts.push(
        item.quantity +
        '× ' +
        name
      );
    }

    return parts.join(' · ');
  }


  /*
   * ============================================================
   * 3. NUR QUOTIFY convert-cart ERGÄNZEN
   * ============================================================
   *
   * Shopify bleibt unangetastet.
   *
   * Quotify erhält weiterhin nur:
   *
   *   Deine Box S
   *
   * Zusätzlich erhält die Parent-Position:
   *
   *   Box Inhalt:
   *   1× Box S ... · 2× GLÜHMIX ... usw.
   *
   * KEINE technischen Variant-IDs mehr.
   */

  window.fetch = async function (
    resource,
    init
  ) {

    try {
      const url =
        typeof resource === 'string'
          ? resource
          : resource && resource.url
            ? resource.url
            : '';

      /*
       * Nur Quotify convert-cart interessiert uns.
       */
      if (!url.includes('convert-cart')) {
        return NativeFetch(
          resource,
          init
        );
      }


      let bodyText = null;

      /*
       * Variante A:
       * fetch(url, {body: ...})
       */
      if (
        init &&
        typeof init.body === 'string'
      ) {
        bodyText = init.body;
      }


      /*
       * Variante B:
       * fetch(Request)
       */
      if (
        !bodyText &&
        resource instanceof NativeRequest &&
        !resource.bodyUsed
      ) {
        try {
          bodyText =
            await resource
              .clone()
              .text();
        } catch (e) {
          bodyText = null;
        }
      }


      /*
       * Falls wir den Request nicht lesen können:
       * Quotify normal weiterlaufen lassen.
       */
      if (!bodyText) {
        return NativeFetch(
          resource,
          init
        );
      }


      let payload;

      try {
        payload =
          JSON.parse(bodyText);
      } catch (e) {
        return NativeFetch(
          resource,
          init
        );
      }


      if (
        !payload ||
        !payload.cart ||
        !Array.isArray(
          payload.cart.items
        )
      ) {
        return NativeFetch(
          resource,
          init
        );
      }


      let boxes = {};

      try {
        boxes =
          JSON.parse(
            localStorage.getItem(
              STORAGE_KEY
            )
          ) || {};
      } catch (e) {
        boxes = {};
      }


      /*
       * Nur Parent-Box ergänzen.
       */
      for (
        const cartItem
        of payload.cart.items
      ) {

        const boxId = String(
          cartItem &&
          cartItem.properties &&
          cartItem.properties._boxi_box_id
            ? cartItem.properties
                ._boxi_box_id
            : ''
        );


        if (
          !boxId ||
          !boxes[boxId]
        ) {
          continue;
        }


        const box =
          boxes[boxId];

        const readable =
          await buildReadableContents(
            box
          );


        cartItem.properties =
          Object.assign(
            {},
            cartItem.properties || {},
            {
              'Box Inhalt': readable
            }
          );


        console.log(
          '[Boxi Quote Bridge] Quotify parent enriched:',
          {
            boxId: boxId,
            readable: readable
          }
        );
      }


      const newBody =
        JSON.stringify(payload);


      /*
       * fetch(url, init)
       */
      if (
        !(
          resource
          instanceof NativeRequest
        )
      ) {

        const newInit =
          Object.assign(
            {},
            init || {},
            {
              body: newBody
            }
          );

        return NativeFetch(
          resource,
          newInit
        );
      }


      /*
       * fetch(Request)
       */
      const newRequest =
        new NativeRequest(
          resource,
          {
            body: newBody
          }
        );


      return NativeFetch(
        newRequest
      );

    } catch (error) {

      console.warn(
        '[Boxi Quote Bridge] convert-cart unchanged because of error:',
        error
      );

      return NativeFetch(
        resource,
        init
      );
    }
  };


  console.log(
    '[Boxi Quote Bridge] ACTIVE'
  );

})();